import { useCacheSlice } from "../hooks";

export type BillingCategory =
	| "hourly"
	| "flat_rate"
	| "pro_bono"
	| "administrative"
	| "internal"
	| "unknown";

export type BillableCategory =
	| "billable"
	| "non_billable"
	| "billable_credit"
	| "unknown";

export type Matter = {
	matter: string | null;
	matter_id: string;
	client: string;
	description: string;
	task_group: string | null;
	activity_group: string | null;
	is_recent?: number;
	recency_rank?: number | null;
	can_select?: boolean;
	billing_category: BillingCategory;
	billable_category: BillableCategory;
};

export function useMattersCache() {
	const { data, isLoading, lastFetchedAt } = useCacheSlice("matters");
	// Only signal loading on the initial fetch — background refetches (window focus,
	// etc.) should not affect taskRequired/activityRequired derived state.
	const isInitialLoading = isLoading && lastFetchedAt === 0;
	return { matters: data, isLoading: isInitialLoading };
}
